import { providerDisplayLabel } from "../../shared/providerIcons";

export const FANOUT_VIEWS = ["graph", "timeline", "sources"];

export const SOURCE_FILTER_OPTIONS = [
	{ id: "cited", label: "Cited" },
	{ id: "fetched", label: "Researched" },
	{ id: "all", label: "All" },
];

export const DEFAULT_FANOUT_VIEW = "graph";

export const STEP_LABEL = {
	reasoning: "Thinking",
	search: "Search",
	open_page: "Open page",
	find_in_page: "Find in page",
	answer: "Answer",
};

export const SOURCE_TYPE_LABEL = {
	cited: "Cited",
	mentioned: "Mentioned",
	fetched: "Researched",
};

export const STATUS_COLORS = {
	cited: "#16a34a",
	brand: "#16a34a",
	mentioned: "#7c3aed",
	fetched: "#d97706",
	competitor: "#dc2626",
	other: "#94a3b8",
};

const PROVIDER_COLORS = {
	openai: "#10A37F",
	gemini: "#4285F4",
	claude: "#D97757",
	perplexity: "#7C3AED",
};

export function analysisEngineLabel(provider) {
	return providerDisplayLabel(provider);
}

export function analysisEngineColor(provider) {
	const key = String(provider || "").toLowerCase();
	return PROVIDER_COLORS[key] || "#64748b";
}

export function parseFanoutView(value) {
	if (value === "list") return DEFAULT_FANOUT_VIEW;
	return FANOUT_VIEWS.includes(value) ? value : DEFAULT_FANOUT_VIEW;
}

export function getSortedQueries(analysis) {
	return [...(analysis?.queries || [])].sort((a, b) => a.seq_order - b.seq_order);
}

export function getSourcesForQuery(analysis, queryId) {
	return (analysis?.sources || []).filter((s) => s.query_id === queryId);
}

export function groupSourcesByType(sources) {
	const grouped = { cited: [], mentioned: [], fetched: [] };
	(sources || []).forEach((source) => {
		if (grouped[source.citation_type]) grouped[source.citation_type].push(source);
	});
	return grouped;
}

export function countSourcesByType(sources) {
	const grouped = groupSourcesByType(sources);
	return {
		cited: grouped.cited.length,
		mentioned: grouped.mentioned.length,
		fetched: grouped.fetched.length,
	};
}

export function splitSearchPhrases(queryText) {
	return String(queryText || "")
		.split(" | ")
		.map((phrase) => phrase.trim())
		.filter(Boolean);
}

export function sourceUrlLabel(source) {
	return source.url || source.domain || "Source";
}

export function sourceSubtitle(source) {
	const parts = [];
	if (source.title && source.title !== source.url) {
		parts.push(source.title);
	}
	if (source.domain) {
		parts.push(source.domain);
	}
	return parts.join(" · ");
}

/** @deprecated Used by graph view nodes only. */
export function sourcePrimaryLabel(source, citationType) {
	if (citationType === "mentioned") {
		return source.title || source.domain || source.url || "Source";
	}
	return source.domain || source.title || source.url || "Source";
}

/** @deprecated Used by graph view nodes only. */
export function sourceSecondaryLabel(source, citationType) {
	if (citationType === "mentioned") return source.domain || "";
	return source.title || "";
}

export function getQueryLabel(analysis, queryId) {
	const query = (analysis?.queries || []).find((item) => item.id === queryId);
	if (!query) return "Unknown step";
	const stepNum = query.seq_order + 1;
	const type = STEP_LABEL[query.action_type] || query.action_type;
	return `Step ${stepNum} · ${type}`;
}
